export const themeJson = {
    "colorPalette": "dark",
    "cssVariables": {
      "--sjs-general-backcolor": "rgba(48, 48, 48, 1)",
      "--sjs-general-backcolor-dark": "rgba(52, 52, 52, 1)",
      "--sjs-general-backcolor-dim": "#303030",
      "--sjs-general-backcolor-dim-light": "rgba(43, 43, 43, 1)",
      "--sjs-general-backcolor-dim-dark": "rgba(46, 46, 46, 1)",
      "--sjs-general-forecolor": "rgba(255, 255, 255, 0.78)",
      "--sjs-general-forecolor-light": "rgba(255, 255, 255, 0.42)",
      "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.79)",
      "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.45)",
      "--sjs-primary-backcolor": "#6DB7FC",
      "--sjs-primary-backcolor-light": "rgba(109, 183, 252, 0.07)",
      "--sjs-primary-backcolor-dark": "rgba(109, 183, 252, 1)",
      "--sjs-primary-forecolor": "rgba(32, 32, 32, 1)",
      "--sjs-primary-forecolor-light": "rgba(32, 32, 32, 0.25)",
      "--sjs-base-unit": "8px",
      "--sjs-corner-radius": "4px",
      "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
      "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
      "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
      "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
      "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
      "--sjs-shadow-small": "0px 1px 2px 0px rgba(0, 0, 0, 0.35)",
      "--sjs-shadow-medium": "0px 2px 6px 0px rgba(0, 0, 0, 0.2)",
      "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
      "--sjs-shadow-inner": "inset 0px 1px 2px 0px rgba(0, 0, 0, 0.2)",
      "--sjs-border-light": "rgba(255, 255, 255, 0.08)",
      "--sjs-border-default": "rgba(255, 255, 255, 0.12)",
      "--sjs-border-inside": "rgba(255, 255, 255, 0.08)",
      "--sjs-special-red": "rgba(254, 76, 108, 1)",
      "--sjs-special-red-light": "rgba(254, 76, 108, 0.1)",
      "--sjs-special-red-forecolor": "rgba(48, 48, 48, 1)",
      "--sjs-special-green": "rgba(36, 197, 164, 1)",
      "--sjs-special-green-light": "rgba(36, 197, 164, 0.1)",
      "--sjs-special-green-forecolor": "rgba(48, 48, 48, 1)",
      "--sjs-special-blue": "rgba(91, 151, 242, 1)",
      "--sjs-special-blue-light": "rgba(91, 151, 242, 0.1)",
      "--sjs-special-blue-forecolor": "rgba(48, 48, 48, 1)",
      "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
      "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
      "--sjs-special-yellow-forecolor": "rgba(48, 48, 48, 1)",
      "--sjs-article-font-xx-large-fontSize": "64px",
      "--sjs-article-font-xx-large-textDecoration": "none",
      "--sjs-article-font-xx-large-fontWeight": "700",
      "--sjs-article-font-xx-large-fontStyle": "normal",
      "--sjs-article-font-xx-large-fontStretch": "normal",
      "--sjs-article-font-xx-large-letterSpacing": "0",
      "--sjs-article-font-xx-large-lineHeight": "64px",
      "--sjs-article-font-xx-large-paragraphIndent": "0px",
      "--sjs-article-font-xx-large-textCase": "none",
      "--sjs-article-font-x-large-fontSize": "48px",
      "--sjs-article-font-x-large-textDecoration": "none",
      "--sjs-article-font-x-large-fontWeight": "700",
      "--sjs-article-font-x-large-fontStyle": "normal",
      "--sjs-article-font-x-large-fontStretch": "normal",
      "--sjs-article-font-x-large-letterSpacing": "0",
      "--sjs-article-font-x-large-lineHeight": "56px",
      "--sjs-article-font-x-large-paragraphIndent": "0px",
      "--sjs-article-font-x-large-textCase": "none",
      "--sjs-article-font-large-fontSize": "32px",
      "--sjs-article-font-large-textDecoration": "none",
      "--sjs-article-font-large-fontWeight": "700",
      "--sjs-article-font-large-fontStyle": "normal",
      "--sjs-article-font-large-fontStretch": "normal",
      "--sjs-article-font-large-letterSpacing": "0",
      "--sjs-article-font-large-lineHeight": "40px",
      "--sjs-article-font-large-paragraphIndent": "0px",
      "--sjs-article-font-large-textCase": "none",
      "--sjs-article-font-medium-fontSize": "24px",
      "--sjs-article-font-medium-textDecoration": "none",
      "--sjs-article-font-medium-fontWeight": "700",
      "--sjs-article-font-medium-fontStyle": "normal",
      "--sjs-article-font-medium-fontStretch": "normal",
      "--sjs-article-font-medium-letterSpacing": "0",
      "--sjs-article-font-medium-lineHeight": "32px",
      "--sjs-article-font-medium-paragraphIndent": "0px",
      "--sjs-article-font-medium-textCase": "none",
      "--sjs-article-font-default-fontSize": "16px",
      "--sjs-article-font-default-textDecoration": "none",
      "--sjs-article-font-default-fontWeight": "400",
      "--sjs-article-font-default-fontStyle": "normal",
      "--sjs-article-font-default-fontStretch": "normal",
      "--sjs-article-font-default-letterSpacing": "0",
      "--sjs-article-font-default-lineHeight": "28px",
      "--sjs-article-font-default-paragraphIndent": "0px",
      "--sjs-article-font-default-textCase": "none",
      "--sjs-font-size": "16px"
    },
    "backgroundImageFit": "cover",
    "backgroundImageAttachment": "scroll"
  }
